<template>
    <div>
        <div v-if="showResidentialTab">
            <!-- Render tabs for Commercial and Residential -->
            <b-tabs>
                <b-tab title="Commercial">
                    <contact-commercial-index
                        :available-columns="availableColumns"
                        :masks="masks"
                        :state="state"
                        :symbols="symbols"
                        :user-role="userRole"
                        :available-sort="availableSort"
                        :custom-fields="customFields"
                        :custom-field-type-constants="customFieldTypeConstants"
                        :calendar="calendar"
                        :can-delete="canDelete"
                        :has-bulk-email-access="hasBulkEmailAccess"
                        :sales-behaviors="salesBehaviors"
                        :user-item-per-page="userItemPerPage"
                        :contact-user-view-list="contactUserViewList"
                        :check-company-contact-mapping="checkCompanyContactMapping"
                        :can-create="canCreate"
                    ></contact-commercial-index>
                </b-tab>
                <b-tab title="Residential">
                    <contact-residential-index
                        :available-columns="availableResidentialColumns"
                        :masks="masks"
                        :residential-state="residentialState"
                        :symbols="symbols"
                        :user-role="userRole"
                        :available-sort="availableSort"
                        :custom-fields="customFields"
                        :custom-field-type-constants="customFieldTypeConstants"
                        :calendar="calendar"
                        :can-delete="canDelete"
                        :has-bulk-email-access="hasBulkEmailAccess"
                        :sales-behaviors="salesBehaviors"
                        :user-item-per-page="userItemPerPage"
                        :contact-user-view-list="residentialContactUserViewList"
                        :can-create="canCreate"
                    ></contact-residential-index>
                </b-tab>
            </b-tabs>
        </div>
        <div v-else>
            <!-- Render the content without tabs -->
            <contact-commercial-index
                :available-columns="availableColumns"
                :masks="masks"
                :state="state"
                :symbols="symbols"
                :user-role="userRole"
                :available-sort="availableSort"
                :custom-fields="customFields"
                :custom-field-type-constants="customFieldTypeConstants"
                :calendar="calendar"
                :can-delete="canDelete"
                :has-bulk-email-access="hasBulkEmailAccess"
                :sales-behaviors="salesBehaviors"
                :user-item-per-page="userItemPerPage"
                :contact-user-view-list="contactUserViewList"
                :can-create="canCreate"
            ></contact-commercial-index>
        </div>

    </div>
</template>

<script>

import Ar from "vuejs-datepicker/dist/locale/translations/ar";

export default {
    name: "contact-index",
    // props:['masks', 'symbols', 'userRole'],
    // components:{CommercialTab, ResidentialTab},
    props:{
        availableColumns: {
            type: Array,
        },
        masks: {},
        state: {
            type: Array,
        },
        residentialState: {
            type: Array,
        },
        symbols: {},
        userRole:{},
        availableSort: {},
        customFields: {
            type: Array,
        },
        customFieldTypeConstants: {},
        calendar: {},
        canDelete: {},
        hasBulkEmailAccess: {},
        salesBehaviors: {
            type: Array,
        },
        userItemPerPage: {},
        showResidentialTab:{},
        availableResidentialColumns:{
            type: Array,
        },
        contactUserViewList: {
            type: Array
        },
        residentialContactUserViewList: {
            type: Array
        },
        checkCompanyContactMapping:{
            type: Boolean,
        },
        canCreate: {}
    },
    data() {
        return {
            activeTabIndex: 0,
        }
    },

    watch: {
        activeTabIndex(newValue) {
            if (newValue === 0) {
                // Commercial tab is active
            } else if (newValue === 1) {
                // Residential tab is active
            }
        }
    },
    methods: {

    }
}
</script>
